import { createElement, FunctionComponent } from 'react'

export const AuroraInputSelectionStyles: FunctionComponent<{
  selectionTextColor: string
  selectionBackgroundColor: string
}> = ({ selectionTextColor, selectionBackgroundColor }) =>
  createElement(
    'style',
    null,
    `
    input::selection,
    textarea::selection {
      color: ${selectionTextColor};
      background-color: ${selectionBackgroundColor};
    }
  `,
  )
